import { useEffect, useMemo } from 'react';
import { supabase } from '../services/supabaseClient';
import useGlobalData from './useGlobalData';
import { useQuery } from '@tanstack/react-query';
import { isEqual } from 'lodash';

/**
 * Optimizuotas hook'as įmonių duomenų gavimui
 * Tiesiogiai atnaujina globalų state vietoj kelių tarpinių žingsnių
 */
export function useCompanies({ kasPildo }) {
    const { companies, setCompanies } = useGlobalData();

    const { data: companiesData, isLoading } = useQuery({
        queryKey: [
          "companies-tendencijos", 
          kasPildo
        ],
        queryFn: async () => {
            return supabase
                .from('atsakymai')
                .select('imones_pavadinimas')
                // .distinct('imones_pavadinimas')
                .eq('kas_pildo', kasPildo)
                .throwOnError()
                .order('imones_pavadinimas');
        },
        enabled: !!kasPildo,
        staleTime: 10 * 60 * 1000, // 10 minutes - companies change infrequently
        cacheTime: 15 * 60 * 1000, // 15 minutes
      });

    // Process companies data locally instead of updating global state
    const processedCompanies = useMemo(() => {
        if (!companiesData?.data) return [];
        return [...new Set(companiesData.data.map(item => item?.imones_pavadinimas))].filter(Boolean);
    }, [companiesData]);

    // Only update global state if we have valid companies and they're different
    useEffect(() => {
        if (processedCompanies.length > 0 && !isEqual(processedCompanies, companies)) {
            setCompanies(processedCompanies);
        }
    }, [processedCompanies, companies, setCompanies]);

    return {
        companies: processedCompanies.length > 0 ? processedCompanies : companies,
        isLoading,
    };
}

export default useCompanies;
